function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * 菜单
 * */
import { cloneDeep } from 'lodash';
import { includeArray, setNativeMenuSider, setNativeMenuHeader, getHeaderName, getMenuSider, getSiderSubmenu, getNativeMenuSider, getNativeMenuHeader } from '@/libs/system';
import router from '@/router';
import { MenuList } from '@api/menu';
import Setting from '@/setting';
import menuSider from '@/menu/sider';

// 根据 menu 配置的权限，过滤菜单
function filterMenu(menuList, access, lastList) {
  menuList.forEach(function (menu) {
    var menuAccess = menu.auth;
    if (!menuAccess || includeArray(menuAccess, access)) {
      var newMenu = {};
      for (var i in menu) {
        if (i !== 'children') newMenu[i] = cloneDeep(menu[i]);
      }
      if (menu.children && menu.children.length) newMenu.children = [];
      lastList.push(newMenu);
      menu.children && filterMenu(menu.children, access, newMenu.children);
    }
  });
  return lastList;
}
export default {
  namespaced: true,
  state: {
    // 顶部菜单
    header: [],
    // 侧栏菜单
    sider: [],
    // 当前顶栏菜单的 name
    headerName: '',
    // 当前所在菜单的 path
    activePath: '',
    // 展开的子菜单 name 集合
    openNames: [],
    // 所有的菜单
    menuSider: [],
    // 侧边菜单徽标
    siderMenuBadge: Setting.badge.siderMenuBadge,
    // 顶栏菜单徽标
    headerMenuBadge: Setting.badge.headerMenuBadge
  },
  getters: {
    /**
     * @description 根据 user 里登录用户权限，对侧边菜单进行鉴权过滤
     * */
    filterSider: function filterSider(state, getters, rootState) {
      var userInfo = rootState.admin.user.info;
      // @权限
      var access = userInfo.access;
      if (access && access.length) {
        return filterMenu(state.sider, access, []);
      } else {
        return filterMenu(state.sider, [], []);
      }
    },
    /**
     * @description 根据 user 里登录用户权限，对顶栏菜单进行鉴权过滤
     * */
    filterHeader: function filterHeader(state, getters, rootState) {
      var userInfo = rootState.admin.user.info;
      // @权限
      var access = userInfo.access;
      if (access && access.length) {
        return state.header.filter(function (item) {
          var state = true;
          if (item.auth && !includeArray(item.auth, access)) state = false;
          if (item.children && item.children.length) {
            item.children = item.children.filter(function (child) {
              var state = true;
              if (child.auth && !includeArray(child.auth, access)) state = false;
              return state;
            });
          }
          return state;
        });
      } else {
        return state.header.filter(function (item) {
          var state = true;
          if (item.auth && item.auth.length) state = false;
          if (item.children && item.children.length) {
            item.children = item.children.filter(function (child) {
              var state = true;
              if (child.auth && child.auth.length) state = false;
              return state;
            });
          }
          return state;
        });
      }
    },
    /**
     * @description 当前 header 的全部信息
     * */
    currentHeader: function currentHeader(state) {
      return state.header.find(function (item) {
        return item.name === state.headerName;
      });
    },
    /**
     * @description 在当前 header 下，是否隐藏 sider（及折叠按钮）
     * */
    hideSider: function hideSider(state, getters) {
      var visible = false;
      if (getters.currentHeader && 'hideSider' in getters.currentHeader) visible = getters.currentHeader.hideSider;
      return visible;
    }
  },
  mutations: {
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setSider: function setSider(state, menu) {
      state.sider = menu;
    },
    /**
     * @description 设置顶栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setHeader: function setHeader(state, menu) {
      state.header = menu;
    },
    /**
     * @description 设置当前顶栏菜单 name
     * @param {Object} state vuex state
     * @param {Array} name headerName
     */
    setHeaderName: function setHeaderName(state, name) {
      state.headerName = name;
    },
    /**
     * @description 设置当前所在菜单的 path，用于侧栏菜单高亮当前项
     * @param {Object} state vuex state
     * @param {Array} path fullPath
     */
    setActivePath: function setActivePath(state, path) {
      state.activePath = path;
    },
    /**
     * @description 设置当前所在菜单的全部展开父菜单的 names 集合
     * @param {Object} state vuex state
     * @param {Array} names openNames
     */
    setOpenNames: function setOpenNames(state, names) {
      state.openNames = names;
    },
    /**
     * @description 设置所有菜单
     * @param {Object} state vuex state
     * @param {Array} menuSider menuSider
     * */
    setMenuSider: function setMenuSider(state, menuSider) {
      state.menuSider = menuSider;
    },
    /**
     * @description 设置全部的侧边菜单的徽标
     * */
    setAllSiderMenuBadge: function setAllSiderMenuBadge(state, data) {
      state.siderMenuBadge = data;
    },
    /**
     * @description 新增或修改某个侧边菜单的徽标
     * */
    setSiderMenuBadge: function setSiderMenuBadge(state, _ref) {
      var path = _ref.path,
        badge = _ref.badge;
      var siderMenuBadge = cloneDeep(state.siderMenuBadge);
      var menuIndex = siderMenuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) {
        siderMenuBadge[menuIndex] = badge;
        state.siderMenuBadge = siderMenuBadge;
      } else {
        state.siderMenuBadge.push(badge);
      }
    },
    /**
     * @description 删除某个侧边菜单的徽标
     * */
    removeSiderMenuBadge: function removeSiderMenuBadge(state, path) {
      var menuIndex = state.siderMenuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) state.siderMenuBadge.splice(menuIndex, 1);
    },
    /**
     * @description 设置全部的顶栏菜单的徽标
     * */
    setAllHeaderMenuBadge: function setAllHeaderMenuBadge(state, data) {
      state.headerMenuBadge = data;
    },
    /**
     * @description 新增或修改某个顶栏菜单的徽标
     * */
    setHeaderMenuBadge: function setHeaderMenuBadge(state, _ref2) {
      var path = _ref2.path,
        badge = _ref2.badge;
      var headerMenuBadge = cloneDeep(state.headerMenuBadge);
      var menuIndex = headerMenuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) {
        headerMenuBadge[menuIndex] = badge;
        state.headerMenuBadge = headerMenuBadge;
      } else {
        state.headerMenuBadge.push(badge);
      }
    },
    /**
     * @description 删除某个顶栏菜单的徽标
     * */
    removeHeaderMenuBadge: function removeHeaderMenuBadge(state, path) {
      var menuIndex = state.headerMenuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) state.headerMenuBadge.splice(menuIndex, 1);
    }
  },
  actions: {
    /**
     * @description 设置菜单（动态+静态）
     * */
    setMenuList: function setMenuList(_ref3) {
      var dispatch = _ref3.dispatch,
        commit = _ref3.commit;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // 只动态菜单设置顶栏菜单
      if (Setting.dynamicMenu) {
        // 设置顶栏菜单
        var menuHeaderList = getNativeMenuHeader();
        commit('setHeader', menuHeaderList);
      }
      // 设置侧边栏菜单
      var menuSiderList = Setting.dynamicMenu ? getNativeMenuSider() : _toConsumableArray(menuSider);
      var path = to.matched[to.matched.length - 1].path;
      var headerName = getHeaderName(path, menuSiderList);
      if (headerName === null) {
        path = to.path;
        headerName = getHeaderName(path, menuSiderList);
      }
      // 在 404 时，是没有 headerName 的
      if (headerName !== null) {
        commit('setHeaderName', headerName);
        commit('setMenuSider', menuSiderList);
        var filterMenuSider = getMenuSider(menuSiderList, headerName);
        commit('setSider', filterMenuSider);
        commit('setActivePath', to.path);
        var openNames = getSiderSubmenu(path, menuSiderList);
        commit('setOpenNames', openNames);
      }
    },
    /**
     * @description 动态获取菜单
     * @param dispatch
     * @param loadMenu 是否加载菜单，需传 $route 信息
     * */
    getMenuList: function getMenuList(_ref4, loadMenu) {
      var dispatch = _ref4.dispatch;
      return new Promise(function (resolve, reject) {
        MenuList().then(function (res) {
          setNativeMenuHeader(res.header);
          setNativeMenuSider(res.sider);
          if (loadMenu) {
            var to = loadMenu === true ? router.currentRoute.value : loadMenu;
            dispatch('setMenuList', to);
          }
          resolve();
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }
};